import { RawLocation } from 'vue-router';

export enum SlotNames {
  INSIDE = 'inside',
  SIDEBAR = 'sidebar',
  TOP = 'top',
}

export enum NamePositions {
  TOP = 'top',
  INSIDE = 'inside',
}

export interface Props {
  address?: string;
  allProgramsTitle?: string;
  borderTop?: boolean;
  email?: string;
  logo?: string;
  municipality?: string;
  municipalityLink?: RawLocation;
  name: string;
  namePosition?: NamePositions;
  phone?: string;
  programsLink?: RawLocation;
  vacanciesLink?: RawLocation;
  wideSidebar?: boolean;
  careerCenter?: object;
  cop_multi_name?: string;
  cop_multi?: string;
}



// WEBPACK FOOTER //
// ./src/components/page/organization/types.ts